import { useLocalStorage } from 'react-use';
import { useLocation } from '@app/router';
import { useIsTransactionFlow } from '@app/transaction';
import { useCustomer, useUserIsLoggedIn } from '@app/user';
import useSmsProfile from './useSmsProfile';

const useShowSmsModal = () => {
  const location = useLocation();
  const customer = useCustomer();
  const isLoggedIn = useUserIsLoggedIn();
  /* Don't fetch unless logged in */
  const { data, error, loading } = useSmsProfile({
    enabled: isLoggedIn,
  });

  const isTransactionFlow = useIsTransactionFlow();

  const restrictedPages = [
    '/terms',
    '/sms-tos',
    '/privacy',
    '/sms',
    '/shipments',
  ];

  const isRestrictedPage = restrictedPages.some((page) =>
    location?.pathname.includes(page),
  );

  const [skippedSmsModal] = useLocalStorage<string>('skipped_sms_modal');

  if (isRestrictedPage || !isLoggedIn) {
    return false;
  }

  const previouslySkippedModal =
    skippedSmsModal && customer?.uuid
      ? JSON.parse(skippedSmsModal)[customer?.uuid]
      : false;

  const hasSmsProfile = !loading && !error && !!data?.getSmsProfile?.phone;

  const showSmsModal =
    !loading && !hasSmsProfile && !isTransactionFlow && !previouslySkippedModal;

  return showSmsModal;
};

export default useShowSmsModal;
